<button
  mat-fab
  color="primary"
  class="fab fab-fixed-right"
  (click)="addFlight()"
  *ngIf="!itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
  <mat-icon>add</mat-icon>
</button>

<app-empty-list-message
  *ngIf="itinerary.reservations.flights.length == 0"
  message="Per questo itinerario non è ancora stato inserito alcun volo."
  actionIcon="add"
  actionLabel="Aggiungi un volo"
  [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
  (actionClick)="addFlight()"
>
</app-empty-list-message>

<mat-accordion>
  <mat-expansion-panel
    *ngFor="
      let flight of itinerary.reservations.flights;
      index as flightId;
      last as last
    "
    [(expanded)]="expanded[flightId]"
  >
    <mat-expansion-panel-header>
      <mat-panel-title fxLayoutAlign="start center">
        <mat-icon class="header-icon">flight</mat-icon>
        <span class="header-title" fxFlex>
          <app-itinerary-reservations-transportation-form-title
            [transportation]="flight"
          ></app-itinerary-reservations-transportation-form-title>
        </span>
        <div class="header-actions">
          <button
            mat-icon-button
            matTooltip="Rimuovi questo volo"
            (click)="removeFlight($event, flight)"
            *ngIf="
              !itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
            "
          >
            <mat-icon aria-label="Rimuovi">delete</mat-icon>
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <app-itinerary-reservations-transportation-form
      [transportation]="flight"
      [transportationId]="flightId"
      [stopsFormFieldLabel]="'Scali'"
      [detailFormFieldLabel]="'aeroporto'"
      [npax]="itinerary.npax"
      [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
    ></app-itinerary-reservations-transportation-form>
  </mat-expansion-panel>
</mat-accordion>
